
export class Formatters {
  static getFormattedDate(dateString: string | null | undefined): string {
    if (!dateString) return "";
  
    const date = new Date(dateString);
    const day = date.getDate();
    
    // Function to get the ordinal suffix (st, nd, rd, th)
    const getOrdinalSuffix = (day: number): string => {
      if (day > 3 && day < 21) return 'th'; // 4th-20th
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };
  
    // Use browser's locale for month and year formatting
    const locale = navigator.language; // Gets the user's locale
    const month = date.toLocaleString(locale, { month: 'long' });
    const year = date.getFullYear();
  
    return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
  }
}